const STORAGE_KEY = 'EMV2'
export const Storage = {
  set(group, key, val, expire) {
    let s = window.localStorage.getItem(STORAGE_KEY)
    let o = {}
    if (s) {
      try {
        o = JSON.parse(s)
      } catch (e) {}
    }
    o = Object.assign({ [group]: {} }, o || {}) //[group];
    o[group][key] = val
    if (expire && expire > 0) {
      o[group][key] = { value: val, expire: new Date().getTime() + expire * 1000 }
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(o))
  },
  get(group, key) {
    let s = window.localStorage.getItem(STORAGE_KEY)
    let o = {}
    if (s) {
      try {
        o = JSON.parse(s)
      } catch (e) {}
    }
    let item = Object.assign({ [group]: {} }, o || {})[group][key]
    if (!item) {
      return null
    }
    if (typeof item === 'string') {
      return item
    }
    if (typeof item === 'object' && item.hasOwnProperty('value') && item.hasOwnProperty('expire')) {
      if (new Date().getTime() < item.expire) {
        return item.value
      }
    }
    Storage.remove(key)
    return null
  },
  remove(group, key) {
    let s = window.localStorage.getItem(STORAGE_KEY)
    let o = {}
    if (s) {
      try {
        o = JSON.parse(s)
      } catch (e) {}
    }
    o = Object.assign({ [group]: {} }, o || {}) //[group];
    if (o[group].hasOwnProperty(key)) {
      delete o[group][key]
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(o))
  },
}
